import React from 'react';

import _ from 'lodash';
import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { HOME_AFFORDABILITY } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  overridesSelector,
  adjustedOutputsSelector,
} from '../../../lib/selectors/home-affordability-calculator-selectors';
import {
  HomeAffordabilityInput,
  INPUT_TRACKING_TYPES,
  inputOnChange,
} from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const DownPaymentInput: React.FC<HomeAffordabilityInput> = ({
  overrides,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip,
  adjustedOutputs,
}) => {
  const value = !_.isNil(overrides?.fundsNeeded)
    ? num.formatCurrency(overrides?.fundsNeeded)
    : '';
  const placeholder = num.formatCurrency(adjustedOutputs?.fundsNeeded);
  const errorMessage = validations?.downPayment?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const legacyAnalytics =
    analyticsEnabled && analytics?.payload?.legacy?.formName;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let legacy;
    if (legacyAnalytics) {
      const legacyProps = analytics?.payload?.legacy;
      legacy = {
        ...legacyProps,
        fieldName: 'fundsNeeded',
        inputType: INPUT_TRACKING_TYPES.TEXT,
      };
    }

    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      legacy,
      bedrock,
      fieldName: 'fundsNeeded',
      overrides: true,
      additionalInputIdsToValidate: ['downPayment'],
      calculator: HOME_AFFORDABILITY,
      inputType: 'currency',
    });
  };

  return (
    <InputMoney
      label={label}
      value={value}
      placeholder={placeholder}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
    />
  );
};

const mapStateToProps = (state) => ({
  overrides: overridesSelector(state),
  validations: validationsSelector(state),
  adjustedOutputs: adjustedOutputsSelector(state),
});

export default connect(mapStateToProps)(DownPaymentInput);
